// extracted by mini-css-extract-plugin
export default {"settingsPage":"SettingsPage_settingsPage__HogHj","main":"SettingsPage_main__eZA0h"};